import React, { useEffect, useState } from 'react'
import Development from '../../assets/development.jpg'
import Business from '../../assets/business.jpg'
import Status from '../../Components/Status/Status'
import CategoryIcon from '@mui/icons-material/Category';
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { useQuery } from 'react-query'
import axios from 'axios'
import {Link} from 'react-router-dom'
import {useNavigate} from 'react-router-dom'
import { api } from '../../api';
import { toast } from 'react-toastify';

export default function Categories() {
    const { isLoading, error, data, refetch } = useQuery('fetchCategories', () =>
            axios(baseUrl + path.fetchCategories, {
        })
    )

    const navigate = useNavigate()
    const [isDeleting, setIsDeleting] = useState(null)

    const deleteRow = (row) => {
        let confirm = window.confirm('Are you sure you want to delete ' + row.name + '?')
        if(confirm){
            setIsDeleting(true)
            api.delete(path.deleteCategory, {
                data: {
                    id: row.id
                }
            }).then(response => {
                let data = response.data
                if(data.success){
                    toast.success('Success!', {hideProgressBar: true})
                    refetch()
                }
            }).finally(() => setIsDeleting(false))
        }
    }

    const editCategory = (row) => {
        navigate("/add-category", { state: { category: row} });
    }

    return [
    <Status title={'Categories'} action={{link: '/add-category', title: 'Add Category'}} />,
    isLoading ? (
        <div className='flex flex-col items-center gap-3'>
            <p className='text-black text-[15px]'>Loading data...</p>
            <Oval
                visible={true}
                height="30"
                width="30"
                color="#198754"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
        </div>
    ) : (
        <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
            <table className='w-full' cellPadding={10}>
                <thead>
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000068] bg-[#ededed]'>
                        <th align='left' className='p-2 text-[14px]'>Category Name</th>
                        <th align='left' className='p-2 text-[14px]'>Category Cover Image</th>
                        <th align='left' className='p-2 text-[14px]'>Action</th>
                    </tr>
                </thead>
                <tbody>
                {(data?.data?.categories || []).map(row => (
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000060]'>
                        <td className='text-[15px]'>{row.name}</td>
                        <td>
                            <img className='w-[70px] h-[70px] object-contain' alt='cover' src={baseUrl + row.cover} />
                        </td>
                        <td>
                            <div className='flex items-center h-full gap-2'>
                            <button onClick={() => {
                                navigate(`/${row.id}/sub-categories`, {
                                    state: {
                                        categoryName: row.name
                                    }
                                })
                            }} className='outline-none border-none bg-black p-2 text-[13px] text-white font-bold px-4 py-2 w-fit flex items-center gap-2'>Show Sub-Categories
                                <CategoryIcon style={{fontSize: 17, color: '#ffffff'}}>Filled</CategoryIcon>
                            </button>
                            <button className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md' onClick={() => editCategory(row)}>
                                Edit
                            </button>
                            <button disabled={isDeleting == row.id} className='text-white px-4 py-2 bg-[#ff0000] text-xs font-bold rounded-md' onClick={() => deleteRow(row)}>
                                {isDeleting == row.id ? (
                                    <Oval
                                        visible={true}
                                        height="17"
                                        width="17"
                                        color="#ffffff"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                        strokeWidth={3}
                                    />
                                ) :  'Delete'}
                            </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
    ]
}
